<template lang="pug">
div
  el-card.card-collapse(shadow="hover")
    div.cardHeader
      b Gerenciar Parcelas e/ou Antecipar/Quitar VTN:
    .row-radio
      el-radio-group.input.padding(
        @input="changeTipo(tipoPagamento)"
        @change="findCalculosQuitacao"
        v-model="tipoPagamento"
      )
        el-radio(label="antecipar") Antecipar/Emitir Parcelas
        el-radio(label="quitar") Quitar
    div
      .row
        el-table(
          :data="dadosVtnAntecipar"
          style="width: 100%"
        )
          el-table-column(
            width="80"
          )
            template(slot-scope="scope")
              el-checkbox(
                v-model="scope.row.flag"
                v-if="scope.row.dataVencimento && tipoPagamento === 'antecipar'"
                :disabled="scope.row.situacao === 'QUITADO' || scope.row.situacao === 'AGUARDANDO_PAGAMENTO' || !scope.row.dataVencimento || scope.row.isReemitida || getOnlyFirstAvailable(scope.row)"
                @change="changeCheckbox(scope.row)")
          el-table-column(
            prop="descricao"
            label="Detalhamento das parcelas"
          )
          el-table-column(
            prop="dataVencimento"
            label="Data Vencimento"
            :formatter="formataData"
          )
          el-table-column(
            prop="valor"
            label="Valor Inicial(R$)"
            :formatter="formataValor"
          )
          el-table-column(
            prop="situacao"
            label="Status"
            :formatter="formatarStatus"
          )
          el-table-column(
            prop="quantidadeUPFPA"
            label="Quantidade em UPFPA"
            :formatter="formataQuantidade"
          )
      .row
        el-table(
          :data="dadosVtnResumo"
          style="width: 100%"
        )
          el-table-column(
            prop="descricao"
            label="Resumo"
          )
          el-table-column(
            prop="valor"
            label="Valor(R$)"
            :formatter="formataValor"
          )
          el-table-column(
            prop="quantidadeUPFPA"
            label="Quantidade em UPFPA"
            :formatter="formataQuantidade"
          )

      app-buttons-cadastro(
        :showButtonSalvar='false',
        :showButtonCancelar='true',
        :showButtonFinalizar='true',
        :isUltimoPasso='true'
        :isPrimeiroPasso='true',
        :isIntroPasso='false',
        @cancelar='cancelar',
        @finalizar='finalizar'
      )
</template>

<script>
import AppDivider from '@/components/AppDivider.vue'
import AppDisplay from '@/components/AppDisplay.vue'
import AppButtonsCadastro from '@/components/AppButtonsCadastro.vue'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppLabel from '@/components/AppLabel'
import axios from '@/utils/api'
import moment from 'moment'

export default {
  components: {
    AppDivider,
    AppDisplay,
    AppButtonsCadastro,
    AppLabel
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      dadosAmortizacao: [],
      dadosAntecipacao: {
        dataVencimento: '',
        qtdParcelas: '',
        valorTotal: this.valorTotal
      },
      vtnId: null,
      dadosVtn: this.$store?.state?.vtn?.dadosVtn,
      disable: [],
      parcelasSelecionadas: [],
      valorTotal: 0,
      qtdParcelas: 0,
      isPara: this.process?.env?.ESTADO === 'pa',
      tipoPagamento: '',
      dadosVtnAntecipar: [],
      vtnDados: [],
      dados: {},
      parcelas: 2,
      vtnDadosQuitar: {},
      check: false,
      dadosVtnResumo: [],
      dataCalculo: null,
      valorParcela: null,
      dadosCalcularAntecipacao: [],
      lastPaidCheck: [],
      dadosBoleto: {}
    }
  },

  async created () {
    this.disable = []
    this.vtnId = this.$route.params.idVtn
    this.tipoPagamento = 'antecipar'
    this.findParcelas(this.vtnId)
  },

  methods: {
    formatarStatus (prop) {
      switch (prop.situacao) {
        case 'QUITADO':
          return 'Pago'
        case 'AGUARDANDO_EMISSAO':
          return 'Aguardando emissão'
        case 'AGUARDANDO_EMISSAO_BOLETO':
          return 'Aguardando Emissão de Boleto'
        case 'AGUARDANDO_PAGAMENTO':
          return 'Aguardando Pagamento'
        case 'VENCIDO':
          return 'Vencido'
        case 'CANCELADO':
          return 'Cancelado'
        case 'TOTAL':
          return ''
        default:
          return 'Aguardando Emissão de Boleto'
      }
    },
    getOnlyFirstAvailable (scope) {
      const dadosVtnAntecipar = this.dadosVtnAntecipar
      const firstUnpaidCheck = dadosVtnAntecipar.filter(dados => dados.situacao === 'CANCELADO' || dados.situacao === 'AGUARDANDO_EMISSAO_BOLETO' || dados.situacao === null || dados.situacao === 'VENCIDO')
      firstUnpaidCheck.sort((a, b) => a.numeroParcela - b.numeroParcela)
      if (scope.numeroParcela === firstUnpaidCheck[0].numeroParcela) {
        return false
      }
      return true
    },
    async findParcelas (id) {
      if (id) {
        this.dados = await axios({
          method: 'GET',
          url: `financeiro/vtn/findVtnAntecipar/${id}`
        })
        this.dados.forEach(resp => {
          resp = {
            ...resp,
            flag: false
          }
          this.dadosVtnAntecipar.push(resp)
        })
      } else {
        this.$router.push({
          name: 'gerenciamento-daes'
        })
      }
    },

    async getParcela (id) {
      this.parcelas = await axios({
        method: 'GET',
        url: `financeiro/vtn/numeroParcelas/${id}`
      })
    },

    finalizar () {
      if (this.dadosCalcularAntecipacao.length > 0 && this.tipoPagamento === 'antecipar') {
        this.$router.push({
          name: 'emitirDaeAntecipar',
          params: {
            idProcesso: this.$route?.params?.processo?.id,
            parcela: this.dadosBoleto,
            emitirDae: true,
            confirmarDados: true,
            visualizarDae: false,
            isVencida: false
          }
        })
      } else if (this.tipoPagamento === 'quitar') {
        if (this.dadosBoleto) {
          this.$router.push({
            name: 'emitirDaeAntecipar',
            params: {
              idProcesso: this.$route?.params?.processo?.id,
              parcela: this.dadosBoleto,
              emitirDae: true,
              confirmarDados: true,
              visualizarDae: false,
              isVencida: false
            }
          })
        } else {
          this.showNotificacao('warning', 'Atenção!', 'Não é possível finalizar, as parcelas já se encontram aguardando pagamento.')
        }
      } else {
        this.showNotificacao('warning', 'Atenção!', 'Não é possível finalizar sem selecionar uma parcela para antecipar.')
      }
    },

    formataValor (prop) {
      return prop.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },

    formataQuantidade (prop) {
      if (prop.quantidadeUPFPA !== 0) {
        const quantidadeFormatada = prop.quantidadeUPFPA.toString().split('.')
        return `${quantidadeFormatada[0]}.${quantidadeFormatada[1].slice(0, 4)}`
      }
      return prop.quantidadeUPFPA
    },
    formataData (prop) {
      if (prop.dataVencimento) {
        return moment(prop.dataVencimento).format('DD/MM/YYYY')
      }
      return ''
    },

    changeTipo (value) {
      this.tipoPagamento = value
    },

    cancelar () {
      this.$router.push({
        name: 'gerenciamento-daes'
      })
    },

    async findCalculosQuitacao () {
      const dadosVtnQuitar = []
      this.dadosVtnAntecipar.forEach(vtn => {
        if (vtn.situacao !== 'QUITADO' && vtn.situacao !== 'TOTAL') {
          dadosVtnQuitar.push(vtn)
        }
      })
      if (this.tipoPagamento === 'quitar' && dadosVtnQuitar.length > 0) {
        const dados = await axios({
          method: 'POST',
          url: `financeiro/vtn/calcularAntecipacao`,
          data: dadosVtnQuitar
        })
        this.dadosVtnResumo = dados.resumoDto
        this.dadosBoleto = dados
      } else {
        this.dadosVtnResumo = []
      }
    },

    async changeCheckbox (prop) {
      this.dadosCalcularAntecipacao = []
      this.dadosVtnAntecipar = this.dadosVtnAntecipar.map(vtn => {
        if (vtn.numeroParcela === prop.numeroParcela) {
          vtn.flag = prop.flag
        }
        return vtn
      })
      this.dadosVtnAntecipar.forEach(vtn => {
        if (vtn.flag) {
          this.dadosCalcularAntecipacao.push(vtn)
        }
      })
      if (this.dadosCalcularAntecipacao.length > 0) {
        const data = await axios({
          method: 'POST',
          url: `financeiro/vtn/calcularAntecipacao`,
          data: this.dadosCalcularAntecipacao
        })
        this.dadosVtnResumo = data.resumoDto
        this.dadosBoleto = data
      } else {
        this.dadosVtnResumo = []
      }
    }

  }
}
</script>

<style lang="scss" scoped>
  .card-collapse {
    border-radius: 10px;
    margin: 20px;
  }

  .margin {
    margin: 20px;
  }

  .margin-top {
    margin-top: 1%;
    margin: 20px;
  }

  #line {
    background-color: gainsboro;
    height: 2px;
    margin: 20px;
  }

  .cardHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 20px;
  }

  .padding {
    padding-left: 15px;
    padding-right: 15px;
  }

  .row-radio {
    display: flex;
    flex-direction: row;
    padding: 20px;
    justify-content: center;
  }

  .row {
    display: flex;
    flex-direction: row;
    padding: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/analise/vtn/AntecipacaoParcelaPa.vue